module.exports = __webpack_public_path__ + "static/media/Muli-Light.bc4db201.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.woff2
// module id = 1290
// module chunks = 1